import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const TINYMCE_SCRIPT_SRC =
  'https://culturebiedev-uploadimages.s3.us-east-1.amazonaws.com/tinymce_7.9.1/tinymce/js/tinymce/tinymce.min.js';

const INLINE_TOOLBAR = 'bold italic underline | fontsize | link | undo redo';
const BLOCK_TOOLBAR =
  'bold italic underline | bullist numlist | alignleft aligncenter alignright | fontsize | link | undo redo';

const PLUGINS = ['lists', 'link', 'autolink'];

// Mirrors the styling other pages use for the inline editor. The editor is
// always inline; the toolbar surface floats above the selection so the page
// layout doesn't shift between view and edit modes.
export default function EditableTextEditor({
  value,
  variant,
  onCommit,
  onCancel,
}) {
  const isInline = variant === 'inline';
  const [html, setHtml] = useState(value || '');
  const htmlRef = useRef(html);
  const committedRef = useRef(false);

  useEffect(() => {
    htmlRef.current = html;
  }, [html]);

  const handleEditorChange = (next) => {
    setHtml(next);
  };

  const commit = () => {
    if (committedRef.current) return;
    committedRef.current = true;
    onCommit(htmlRef.current);
  };

  const cancel = () => {
    if (committedRef.current) return;
    committedRef.current = true;
    onCancel();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      cancel();
    }
    if (isInline && e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      commit();
    }
  };

  return (
    <div onKeyDown={handleKeyDown} className="editable__tinymce">
      <Editor
        tinymceScriptSrc={TINYMCE_SCRIPT_SRC}
        inline={true}
        value={html}
        onEditorChange={handleEditorChange}
        onBlur={commit}
        init={{
          license_key: 'gpl',
          branding: false,
          suffix: '.min',
          menubar: false,
          statusbar: false,
          plugins: PLUGINS,
          toolbar_location: 'top',
          toolbar_sticky: false,
          toolbar: isInline ? INLINE_TOOLBAR : BLOCK_TOOLBAR,
          fontsize_formats: '10px 12px 14px 16px 18px 22px 28px 36px',
          forced_root_block: 'p',
          // Render the toolbar above-everything so paginator measurement
          // containers (overflow:hidden) don't clip it.
          setup: (editor) => {
            editor.on('init', () => {
              try {
                editor.focus();
              } catch (e) {
                /* ignore */
              }
            });
          },
        }}
      />
    </div>
  );
}
